import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tip-card',
  templateUrl: './tip-card.component.html',
  styleUrls: ['./tip-card.component.scss'],
  standalone: false
})
export class TipCardComponent implements OnInit {
  @Input() message: string;

  @Input() icon: string;

  constructor() {}

  ngOnInit() {}
}
